import {Injectable, Renderer2, RendererFactory2} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DomListenerService {
  private listeners: { element: HTMLElement, event: string, handler: ()=>void }[] = [];
  private renderer: Renderer2;
  constructor(rendererFactory: RendererFactory2) {
      this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * register the event listerner when reload or append new element
   * @param elementOrSelector 
   * @param event 
   * @param handler 
   */
  addListener(elementOrSelector: NodeListOf<HTMLElement> | string, event: string, handler: EventListener): void {
    let elements: NodeListOf<HTMLElement>;
    if (typeof elementOrSelector === 'string') {
      elements = document.querySelectorAll(elementOrSelector);
    } else {
      elements = elementOrSelector;
    }
    
    elements.forEach(element => {
      this.removeListener(element, event);
      const listener = this.renderer.listen(element, event, (event:Event) => handler(event));
      this.listeners.push({ element, event, handler: listener });
    });
  }

  /**
   * remove the specific listner
   * @param element 
   * @param event 
   */
  removeListener(element: HTMLElement, event: string): void {
    const index = this.listeners.findIndex(l => l.element === element && l.event === event);
    if (index !== -1) {
      this.listeners[index].handler();
      this.listeners.splice(index, 1);
    }
  }


  /**
   * remove all the event listner when component destroy
   */
  removeAllListeners(): void {
    this.listeners.forEach(({ handler }) => handler());
    this.listeners = [];
  }
}
